import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducerProvider, reducerToken } from './reducers/index';
import { WISHLIST_FEATURE } from './wishlist-state';

@NgModule({
  imports: [StoreModule.forFeature(WISHLIST_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class WishlistStoreModule {}
